module.exports = __webpack_public_path__ + "static/media/scooter-half.4c9563a4.png";